import { SET_SIDEBAR_COLLAPSED } from '../../utils/constants/action-types';

interface LayoutState {
  isSidebarCollapsed: boolean;
}

// Load initial state from localStorage
const getInitialSidebarState = (): boolean => {
  try {
    const savedState = localStorage.getItem('sidebarCollapsed');
    if (savedState !== null) {
      return JSON.parse(savedState);
    }
  } catch (error) {
    console.error('Error loading sidebar state from localStorage:', error);
  }
  return false;
};

const initialState: LayoutState = {
  isSidebarCollapsed: getInitialSidebarState(),
};

const layoutReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_SIDEBAR_COLLAPSED:
      const newState = {
        ...state,
        isSidebarCollapsed: action.payload,
      };

      // Save to localStorage
      try {
        localStorage.setItem('sidebarCollapsed', JSON.stringify(action.payload));
      } catch (error) {
        console.error('Error saving sidebar state to localStorage:', error);
      }

      return newState;
    default:
      return state;
  }
};

export default layoutReducer;
